module.exports = __webpack_public_path__ + "static/img/hat2019.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hat2019.jpg
// module id = n0XU
// module chunks = 0